module.exports = __webpack_public_path__ + "static/img/watefull-btn.4cdff43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/watefull-btn.png
// module id = xxLH
// module chunks = 1